import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'button[customButton][isLoading], a[customButton][isLoading]', templateUrl: './button.component.html', styleUrls: ['./button.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ButtonComponent {
    @Input() styleType!: 'primary' | 'secondary' | 'danger' | 'disabled' | 'success';
    @Input() label: string = '';
    @Input() isDisabled: boolean = false;
    @Input() isLoading: boolean;
    @Input() iconName: string | undefined = undefined;
    @Input() outline: boolean = false;

    @HostBinding('class.btn-component')
    _btnComponent = true;

    @HostBinding('class.btn')
    _btn = true;

    @HostBinding('attr.disabled')
    get disabled(): boolean { return this.isDisabled || this.isLoading ? true : null; }

    @HostBinding('class.btn-component__primary')
    get primary(): boolean { return !this.outline && this.styleType === 'primary'; }

    @HostBinding('class.btn-component__outline-primary')
    get outlinePrimary(): boolean { return this.outline && this.styleType === 'primary'; }

    @HostBinding('class.btn-component__secondary')
    get secondary(): boolean { return !this.outline && this.styleType === 'secondary'; }

    @HostBinding('class.btn-component__outline-secondary')
    get outlineSecondary(): boolean { return this.outline && this.styleType === 'secondary'; }
}
